import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'

export const translate = (key: string, values?: Array<string | number>) => {
	const { translations } = useAppConfigStore.getState()

	const translation = translations[key]

	if (!translation || translation.length === 0) return `i18n -> ${key}`

	if (!values) return translation

	return translation.replace(/\{(\d+)\}/g, (_, index) => {
		return String(values[index])
	})
}
